import React, { useEffect, useState } from "react";
import { Col, Container, Row, Stack, Nav, Tab, Tabs, Button } from "react-bootstrap";
import TODIS_FORM_GENERAL from "./form/GENERAL/iwwportsgeneral";
import TODIS_FORM_DESC from "./form/GENERAL/description";
import TODIS_FORM_TENCOMPLIANCE from "./form/GENERAL/freighterminaltencompliance";
import TODIS_FORM_ELEGPROJECT from "./form/GENERAL/freighterminalselegibilityproject";
import TODIS_FORM_INDICATORS from "./form/GENERAL/indicators";
import TODIS_FORM_PERFOMANCE_INDICADOR from "./form/GENERAL/perfomanceindicador";
import TODIS_FORM_STATUS from "./form/IRAILS/status";
import { TODIS_FORM_FIELD, TODIS_FORM_FIELD_YES_NO,TODIS_FORM_DSC } from "../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsExclamationCircleFill } from "react-icons/bs";
const TODIS_FORM = ({ errors, touched, status }) => {
    return (
        <Tabs defaultActiveKey="General" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">

            <Tab eventKey="General" title="General" >
                <Container>
                    <Row>
                        <TODIS_FORM_GENERAL errors={errors} touched={touched} disabled={status}/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="remarks" label="Remarks" name="remarks" disabled={status}/>
                            {errors.remarks && touched.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="remarks" title="Description">
                <Container>
                    <Row>
                        <TODIS_FORM_DESC errors={errors} touched={touched} disabled={status} TypeForm="freightImpPmDescDTO"/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="freightImpPmDescDTO.remarks" label="Remarks" name="freightImpPmDescDTO.remarks" disabled={status}/>
                            {errors.freightImpPmDescDTO && errors.freightImpPmDescDTO.remarks && touched.freightImpPmDescDTO && touched.freightImpPmDescDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.freightImpPmDescDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="status" title="Status">
                <TODIS_FORM_STATUS errors={errors} touched={touched} disabled={status} TypeForm="freightImpPmStatusDTO"/>
            </Tab>
            <Tab eventKey="elegibilityproject" title="TEN-T Project ">
                <Container>
                    <Row>
                        <TODIS_FORM_ELEGPROJECT errors={errors} touched={touched} disabled={status} TypeForm="freightImpPmEligiTentDTO" />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="freightImpPmEligiTentDTO.remarks" label="Remarks" name="freightImpPmEligiTentDTO.remarks" disabled={status}/>
                            {errors.freightImpPmEligiTentDTO && errors.freightImpPmEligiTentDTO.remarks && touched.freightImpPmEligiTentDTO && touched.freightImpPmEligiTentDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.freightImpPmEligiTentDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="tencompliance" title="TEN-T Compliance">
                <Container>
                    <Row>
                        <TODIS_FORM_TENCOMPLIANCE errors={errors} touched={touched} disabled={status} TypeForm="freightImpPmTentcompDTO"/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="freightImpPmTentcompDTO.remarks" label="Remarks" name="freightImpPmTentcompDTO.remarks" disabled={status}/>
                            {errors.freightImpPmTentcompDTO && errors.freightImpPmTentcompDTO.remarks && touched.freightImpPmTentcompDTO && touched.freightImpPmTentcompDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.freightImpPmTentcompDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="perfomanceindicador" title="Performance Indicators">
                <Container>
                    <Row>
                        <TODIS_FORM_PERFOMANCE_INDICADOR errors={errors} touched={touched} disabled={status} TypeForm="freightImpPmPiDTO" Name1="forecastTerminalTraffic" Name2="actualTerminalTraffic" Label1="Terminal traffic - forecasted" Label2="Terminal traffic - actual"/>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="freightImpPmPiDTO.remarks" label="Remarks" name="freightImpPmPiDTO.remarks" disabled={status}/>
                            {errors.freightImpPmPiDTO && errors.freightImpPmPiDTO.remarks && touched.freightImpPmPiDTO && touched.freightImpPmPiDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.freightImpPmPiDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab> 
            <Tab eventKey="indicators" title="Indicators">
                <Container>
                    <Row>
                        <TODIS_FORM_INDICATORS errors={errors} touched={touched} disabled={status} TypeForm="freightImpPmIndicatorsDTO" />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="freightImpPmIndicatorsDTO.remarks" label="Remarks" name="freightImpPmIndicatorsDTO.remarks" disabled={status}/>
                            {errors.freightImpPmIndicatorsDTO && errors.freightImpPmIndicatorsDTO.remarks && touched.freightImpPmIndicatorsDTO && touched.freightImpPmIndicatorsDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.freightImpPmIndicatorsDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
        </Tabs>
    )
}
export default TODIS_FORM;